import React, { useContext, useEffect, useState } from 'react'
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import Popup from '../Common/Popup';

function DealTypeFilter({ 
    TypeOption,
    setTypeOption,
    customPathname,
    dataPath,
    label = "Type",
    isPopupOpen,
    setIsPopupOpen
}) {

    const { typeFilterResponse, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;
    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.type?.map(value => value.id) ?? [];
        setTypeOption(typeFilterResponse[dataPath]?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })))
    }, [typeFilterResponse, customPathname, refineSearchFilters, setTypeOption, dataPath])

    const handleDealTypeChange = (e) => {
        const value = e.target.value;
        setTypeOption(TypeOption?.map(type => ({ 
            ...type, 
            isChecked: value === "" ? false : type.id === parseInt(value) 
        })));
    };

    const selected = TypeOption?.filter(option => option.isChecked)?.at(0);

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100  text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2 flex items-center gap-2">
                    {label}
                    {TypeOption?.length > 0 && (
                        <span className="opacity-60 ml-2 text-xs text-ellipsis">
                            e.g. {TypeOption.slice(0, 2).map(item => item.name).join(', ')}
                        </span>
                    )}
                </span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selected?.name && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selected.name}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <div className="space-y-2">
                            <div className="max-h-60 overflow-y-auto grid grid-cols-3">
                                <label className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                    <input
                                        type="radio"
                                        name="reType"
                                        value=""
                                        checked={!selected}
                                        onChange={handleDealTypeChange}
                                        className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                    />
                                    <span className="text-[13px] font-semibold">All</span>
                                </label>
                                {TypeOption && TypeOption.length > 0 ? (
                                    TypeOption.map((dealType, index) => (
                                        <label key={dealType.id} className="flex items-center space-x-2 hover:bg-gray-50 rounded cursor-pointer">
                                            <input
                                                type="radio"
                                                name="reType"
                                                value={dealType.id}
                                                checked={selected?.id === dealType.id}
                                                onChange={handleDealTypeChange}
                                                className="text-[#D9BD7F] focus:ring-[#D9BD7F]"
                                            />
                                            <span className="text-[13px] font-semibold text-black">{dealType.name}</span>
                                        </label>
                                    ))
                                ) : (
                                    <div className="text-sm text-gray-500 p-2">No results found!</div>
                                )}
                            </div>
                        </div>
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default DealTypeFilter